import { render, staticRenderFns } from "./RichTextCode.vue?vue&type=template&id=1e35172a&"
import script from "./RichTextCode.vue?vue&type=script&lang=js&"
export * from "./RichTextCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports